import React from 'react'

export interface MonthData {
    label: string
    position: number
}

export interface MonthHeaderProps {
    months: MonthData[]
}

const MonthHeader: React.FC<MonthHeaderProps> = ({ months }) => {
    return (
        <div style={{
            height: '40px',
            borderBottom: '1px solid #d3dae6',
            position: 'relative',
            marginBottom: '10px',
            width: '100%',
            display: 'flex'
        }}>
            {months.map((month, index) => (
                <div
                    key={index}
                    style={{
                        flex: '1',
                        fontSize: '12px',
                        color: '#69707d',
                        borderLeft: index > 0 ? '1px solid #d3dae6' : 'none',
                        paddingLeft: '4px',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        textAlign: 'left',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap'
                    }}
                >
                    {month.label}
                </div>
            ))}
        </div>
    )
}

export default MonthHeader 